module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/importar-permissoes/importar-permissoes.component.scss
// module id = ./src/app/shared/componentes/importar-permissoes/importar-permissoes.component.scss
// module chunks = main